import * as Yup from "yup";
import OrganizationSignUpValidation from "./organizationSignUp.validation";
import PhysicianSignUpValidation from "./physicianSignUp.validation";
import UserSignUpValidation from "./userSignUp.validation";

const SignUpFlowValidation = Yup.object().shape({
  org: OrganizationSignUpValidation,
  role:Yup.string().required(),
  user: Yup.object()
    .shape({})
    .when("role", {
      is: (role: string) => role === "Both" || role === "Physician",
      then: (schema) => schema.concat(PhysicianSignUpValidation),
      otherwise: (schema) => schema.concat(UserSignUpValidation),
    }),
  // physicianData: PhysicianSignUpValidation,
  // officeManagerData: UserSignUpValidation.notRequired(),
});
export default SignUpFlowValidation;
